<div class="modal-header border m-2 p-3 pe-3 rounded-3 bg-warning-subtle">
    <div class="d-flex align-items-center gap-3">
        <span class="icon text-warning rounded-circle d-inline-flex align-items-center justify-content-center">
            <app-icon name="alert-triangle" [size]="32" [strokeWidth]="2.2" color="#856404"></app-icon>
        </span>
        <h3 class="modal-title h6 mb-0 fw-bold text-wrap">
            Condición Especial Detectada
        </h3>
    </div>
    <button type="button" class="btn-close focus-ring focus-ring-light" aria-label="Cerrar" (click)="cancel()"></button>
</div>

<div class="modal-body pt-0 px-3">
    <div class="alert alert-warning border-0 bg-transparent p-0 mb-3">
        <p class="mb-2">
            De acuerdo a sus respuestas, los siguientes seguros requieren una evaluación especial:
        </p>
        <ul class="mb-0 ps-0 list-unstyled d-flex flex-column gap-2">
            @for (affected of affectedInsurances; track affected.name) {
            <li>
                <div class="fw-bold text-dark">{{ affected.name }}</div>
                <ul class="ps-3 mt-1 small text-muted">
                    @for (q of affected.questions; track q.text) {
                    @if (q.answer) {
                    <li>{{ q.text }}</li>
                    }
                    }
                </ul>
            </li>
            }
        </ul>
    </div>

    <p class="text-muted small mb-3">
        Por favor, complete la siguiente información para que un representante se comunique con usted y continúe con el
        proceso.
    </p>

    <form [formGroup]="form" class="d-flex flex-column gap-3">
        <div class="form-group">
            <label for="specialRequestNombre" class="form-label small fw-semibold text-muted text-uppercase">Nombre
                Completo</label>
            <input type="text" class="form-control py-2 focus-ring border-success fw-bold focus-ring-success"
                id="specialRequestNombre" placeholder="Ingrese su nombre completo" formControlName="nombre"
                [sharedFormInput]="{
          required: 'El nombre es obligatorio'
        }">
        </div>

        <div class="form-group">
            <label for="specialRequestCedula" class="form-label small fw-semibold text-muted text-uppercase">Cédula /
                RNC</label>
            <input type="text" class="form-control py-2 focus-ring border-success fw-bold focus-ring-success"
                id="specialRequestCedula" placeholder="Cédula o RNC" formControlName="cedula" mask="0-00-00000-0||000-0000000-0"
                [sharedFormInput]="{
          required: 'La cédula o RNC es obligatoria'
        }">
        </div>

        <div class="form-group">
            <label for="specialRequestEmail" class="form-label small fw-semibold text-muted text-uppercase">Correo
                Electrónico</label>
            <input type="email" class="form-control py-2 focus-ring border-success fw-bold focus-ring-success"
                id="specialRequestEmail" placeholder="ejemplo@correo.com" formControlName="email" [sharedFormInput]="{
          required: 'El correo electrónico es obligatorio',
          email: 'Ingrese un correo electrónico válido'
        }">
        </div>

        <div class="form-group">
            <label for="specialRequestTelefono"
                class="form-label small fw-semibold text-muted text-uppercase">Teléfono</label>
            <input type="text" class="form-control py-2 focus-ring border-success fw-bold focus-ring-success"
                id="specialRequestTelefono" placeholder="(809) 000-0000" formControlName="telefono"
                mask="(000) 000-0000" [sharedFormInput]="{
          required: 'El teléfono es obligatorio'
        }">
        </div>
    </form>
</div>

<div class="modal-footer border-0 pb-0 pt-2 justify-content-between">
    <button type="button" class="btn btn-outline-secondary rounded-pill" (click)="cancel()">Cancelar</button>
    <button type="button" class="btn btn-warning rounded-pill fw-semibold" (click)="submit()">Enviar Solicitud</button>
</div>